var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMoreCircleIcon = function SvgMoreCircleIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "currentColor",
    viewBox: "0 0 34 34"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.01,
    d: "M0 0h34v34H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M11.688 17a2.125 2.125 0 1 1-4.25 0 2.125 2.125 0 0 1 4.25 0M17 14.875a2.125 2.125 0 1 0 0 4.25 2.125 2.125 0 0 0 0-4.25m7.438 0a2.125 2.125 0 1 0 0 4.25 2.125 2.125 0 0 0 0-4.25m8.5 2.125c0 8.802-7.136 15.938-15.938 15.938S1.063 25.802 1.063 17 8.198 1.063 17 1.063A15.937 15.937 0 0 1 32.938 17m-2.126 0c0-7.628-6.184-13.812-13.812-13.812S3.188 9.372 3.188 17 9.372 30.813 17 30.813A13.81 13.81 0 0 0 30.813 17",
    clipRule: "evenodd"
  })));
};
export default SvgMoreCircleIcon;